<div class="exception-body accessdenied">
  <div class="exception-panel">
    <div class="exception-image">
      <img
        alt="Icon Access"
        src="assets/layout/images/exception/icon-access.png" />
    </div>

    <div class="exception-detail">
      <h1>ACCESS DENIED</h1>
      <p>You do not have the necessary permissons.</p>
      <p-button [routerLink]="['/']">GO TO DASHBOARD</p-button>
    </div>
  </div>
</div>
